import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect } from 'react-router-dom';
import { renderToStaticMarkup } from 'react-dom/server';

import InputField from 'components/LoginForm/Input';
import SellingPoints from 'components/SellingPoints';
import { companyWebsite, name } from 'settings';

import logo from 'assets/images/logo/logo_wide.png';

const NoAgentScreen = () => (
  <div className="noAgent__container">
    <img src={logo} alt={`${name} logo`} />
    <h5>{i18n.translate('loginScreen.noAgent.title')}</h5>
    <p>{i18n.translate('loginScreen.noAgent.messageWeb')}</p>
    <p>
      <a href={companyWebsite}>{companyWebsite}</a>
    </p>
    <a href={companyWebsite}>
      <button>{i18n.translate('loginScreen.noAgent.visitWebsite')}</button>
    </a>
  </div>
);

export default class Email extends Component {
  constructor(props) {
    super(props);

    this.state = {
      noAgent: false,
      redirect: '',
    };
  }

  render() {
    const { noAgent, redirect } = this.state;
    const {
      defaultVal,
      change,
      submit,
      loadingAnim,
      signUpRoute,
      forgotPasswordRoute,
    } = this.props;

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    return (
      <div className="Email">   
        <h3>{i18n.translate('loginScreen.welcome.headerTop')}</h3>
        <h3>{i18n.translate('loginScreen.welcome.headerBottom')}</h3>
        <SellingPoints />
        {/* <hr /> */}
        <div className="Email__input">
          <legend>
            {i18n.translate('loginScreen.emailPrompt')}
            <br />
          </legend>
          <InputField
            defaultVal={defaultVal}
            change={change}
            fieldType="email"
            fieldName="email"
            fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
            icon="at"
            line
          />
          <InputField
            change={change}
            fieldType="password"
            fieldName="password"
            fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
            icon="key"
            autocomplete="password"
            line
          />
          <div className="login__form--buttons">
            <div className="Email__input--holder">  
              <button
                type="button"
                className="Email__input--button btnInverse"
                onClick={signUpRoute}
              >
                Register
              </button>
              <button
                type="submit"
                onClick={submit}
                className="Email__input--button"
              >
                {loadingAnim ? <span><FontAwesomeIcon icon={['fas', 'circle-notch']} spin /></span> : i18n.translate('general.logIn')}

                {redirect.length > 0 && <Redirect to={redirect} />}
              </button>
            </div>
            {forgotPasswordRoute}
            <button onClick={forgotPasswordRoute} className="Email__input--forgotPassword-btn">
              <span className="Email__input--forgotPassword">Forgot Password?</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Email.propTypes = {
  defaultVal: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnim: PropTypes.bool.isRequired,
  signUpRoute: PropTypes.func.isRequired,
  forgotPasswordRoute: PropTypes.func.isRequired,
};
